import React, { JSX } from 'react'

interface EmptyDataCardProps {
  message?: string
}

export const EmptyDataCard = ({ message = 'Nothing to report in this date range' }: EmptyDataCardProps): JSX.Element => {
  return (
    <div data-testid='empty-data-card' className='flex items-center justify-center h-96 rounded-2xl'>
      <div className='text-center'>
        <div className='flex h-16 items-center justify-center'>
          <img alt='StagePilot Logo' src='/images/logo-letters.png' className='w-auto h-8' />
        </div>
        <p data-testid='empty-data-card-message' className='mt-2 text-sm '>
          {message}
        </p>
      </div>
    </div>
  )
}
